
class PaymentSerializer {
  static deSerialize(data) {
    return {
      datePay: data.FechaPago || '',
      idTicket: data.IDRecibo,
      amount: data.ImportePago,
      paymentTicket: data.ReciboPago,
    };
  }
}

export { PaymentSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/PaymentSerializer.js